<template>
    <div class="row headerPaneHorizontal">
        <div class="col-12">
            <div class="row headerPaneRowCombined">

                <div class="col-6 headerTXOCBox01">
                    <img class="headerTXOCLogo" alt="Oncourse logo" src="../assets/txocLogoHorizontal.svg">
            <span style="padding-left: 1em; font-size: 8pt;">
             <a href="/">Progress Home</a>
             <span style="margin-left: 1em;">
             <a href="/samples">Demo Page</a>
             </span>
             </span>
                </div>
                <div class="col-6 headerLoginBox01">
                    <a class="headerLanguage" :href="'/samples/language_switch?lang='
                                    + newLang
                                    + '&origpath='
                                    + this.$route.fullPath">{{newLangTitle}}</a>
                    <router-link to='/samples/login'>
                    <img class="headerLoginIcon" alt="User Sign In" src="../assets/userIcon.png">
                    </router-link>
                </div>

                <div class="col-6 headerTXOCBox02">
                    <img class="headerTXOCLogo" alt="Oncourse logo" src="../assets/txocLogoHorizontal.svg">
                </div>
                <div class="col-6 headerLoginBox02">
                    <a class="headerLanguage" :href="'/language_switch?lang='
                                    + newLang
                                    + '&origpath='
                                    + this.$route.fullPath">{{newLangTitle}}</a>
                    <router-link to='/samples/login'>
                    <img class="headerLoginIcon" alt="User Sign In" src="../assets/userIcon.png">
                    </router-link>
                </div>

            </div>
            <div class="row">
                <div class="col-12 headerSeparator"></div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            // let langChoice = this.$cookies.get('langChoice');
            let newLang;
            let newLangTitle;
            if (this.$store.state.langChoice === 'en') {
                newLang = 'es';
                newLangTitle = 'Español';
            } else {
                newLang = 'en';
                newLangTitle = 'English';
            }
            // console.log(this.$route.fullPath);
            return {
                envVars: process.env,
                store: this.$store,
                newLang: newLang,
                newLangTitle: newLangTitle
            };
        },
        props: {
            msg: String
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../styles/header";
</style>
